import { getElementExists } from "../helper/helper";

export function initNavIcon() {
  const navIcon = document.getElementById("mb-nav-icon");
  const mainMenuContainer = document.getElementById("mb-main-menu");
  const mainMenu = document.getElementById("menu-mainmenu");

  // Toggle nav with navicon
  if (getElementExists(navIcon)) {
    navIcon.addEventListener("click", function () {
      navIcon.classList.toggle("open");

      if (getElementExists(mainMenuContainer)) {
        mainMenuContainer.classList.toggle("open");
      }
    });
  }

  // Toggle nav when nav item clicked
  if (getElementExists(mainMenu)) {
    const mainMenuItems = mainMenu.querySelectorAll(".menu-item");

    for (let i = 0; i < mainMenuItems.length; i++) {
      mainMenuItems[i].addEventListener("click", function (e) {
        if (e.target.classList.contains("dropdown-toggle")) return;

        if (getElementExists(navIcon)) {
          navIcon.classList.remove("open");
        }

        if (getElementExists(mainMenuContainer)) {
          mainMenuContainer.classList.remove("open");
        }
      });
    }
  }
}
